<template>
  <h1 class="text-center mb-5 text-primary">
    <slot>{{ $route.name }}</slot>
  </h1>
</template>

<script>
export default {
  components: {},
  name: "titular",
};
</script>